{
    "TelephoneserverLabel": "Server telefonico:",
    "PartitionsLabel": "Partizione\/i:",
    "ScopeFiltering_SectionHeader": "Filtraggio dell'ambito",
    "NAME": "ScopeFiltering"
}